
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leagues",
      function () {
        return require("private-next-pages/leagues/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leagues"])
      });
    }
  